import { SIDE_MENU_SHOW_HIDE } from '../constants'
import {createAction} from "redux-actions";

export const sideMenuShowHide = createAction(SIDE_MENU_SHOW_HIDE);

export const showHideScreenSize = (open) => {
    return (dispatch) => dispatch(sideMenuShowHide(open))
};